
<navbar></navbar>
<div class="container">
    <router-outlet></router-outlet>
</div>





